/**
 * Production-safe logging utility
 * Temporarily enabled in production for debugging
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const isDebugMode = true; // TEMP: Enable for production debugging

export const logger = {
  log: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.log(...args);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.warn(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors
    console.error(...args);
  },
  
  debug: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.debug(...args);
    }
  },
  
  // For important info that should show in production too
  info: (...args) => {
    if (isDevelopment || isDebugMode) {
      console.info(...args);
    }
  }
};

export default logger;
